import request from "@/utils/request";

export default function agentGetDeviceInfoBySn(sn) {
    return request({
        url: `/device/device/agentGetDeviceInfoBySn/${sn}`,
    })
}